import Dexie from 'dexie';

export const db = new Dexie('wikitot');

db.version(1).stores({
  tracks: '++id, hash, name, source, addedAt',
});

db.version(2).stores({
  tracks: '++id, hash, name, source, ownerLabel, addedAt',
}).upgrade(async (tx) => {
  await tx.table('tracks').toCollection().modify((t) => {
    if (!t.ownerLabel) t.ownerLabel = 'Importado';
  });
});

export async function loadAllTracks() {
  return db.tracks.orderBy('addedAt').toArray();
}

export async function saveTrack(track) {
  return db.tracks.add(track);
}

export async function removeTrack(id) {
  return db.tracks.delete(id);
}

export async function clearAllTracks() {
  return db.tracks.clear();
}

export async function trackHashExists(hash) {
  if (!hash) return false;
  const found = await db.tracks.where('hash').equals(hash).first();
  return !!found;
}

export async function hashString(s) {
  if (!globalThis.crypto?.subtle) {
    let h = 0;
    for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
    return String(h);
  }
  const enc = new TextEncoder().encode(s);
  const buf = await crypto.subtle.digest('SHA-256', enc);
  return [...new Uint8Array(buf)].slice(0, 12).map((b) => b.toString(16).padStart(2, '0')).join('');
}
